import React from 'react';
import { Field, useFormikContext } from 'formik';
import { get } from 'lodash';

import {
  AuInputLabel,
  AuErrorText,
  AuHintText,
  AuFormItemWrapper
} from 'components/DTA';

import './AuTextInput.scss';

export interface IAuTextInputProps {
  name: string;
  label?: string;
  hintText?: string | React.ReactNode;
  as: 'input' | 'textarea';
  type?: 'text';
  className?: string;
  dark?: boolean;
  block: boolean;
  number?: boolean;
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  style?: React.CSSProperties;
  disabled?: boolean;
}

/**
 * DEFAULT
 * The AuTextInput component wrapping the Formik Field component
 *
 */
const AuTextInput: React.FC<IAuTextInputProps> = ({ name, label, hintText, as, dark, block, number, width, disabled, type = 'text', className = '', ...attributeOptions }) => {
  const { errors, getFieldMeta } = useFormikContext();
  const fieldError = get(errors, name);

  return (
    <AuFormItemWrapper>
      {
        label && <AuInputLabel text={label} htmlFor={name} />
      }
      {
        hintText && <AuHintText text={hintText} htmlFor={name} />
      }
      <Field
        name={name}
        as={as}
        className={
          `au-text-input ${className}` +
          `${block ? ' au-text-input--block' : ''}` +
          `${dark ? ' au-text-input--dark' : ''}` +
          `${number ? ' au-text-input--number' : ''}` +
          `${getFieldMeta(name).error && !disabled ? ' au-text-input--invalid' : ''}` +
          `${width ? ' au-text-input--width-' + width : ''}`
        }
        type={as === 'textarea' ? 'textarea' : type}
        disabled={disabled}
        {...attributeOptions} />

      {fieldError && !disabled &&
        <AuErrorText text={get(errors, name)} />
      }
    </AuFormItemWrapper>
  );
};

export default AuTextInput;